import React, { useState } from 'react';
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import { Navigate, useNavigate } from 'react-router-dom';
import '../Video/Addvideo.css';
import 'react-toastify/dist/ReactToastify.css';
import { AddNewAdminUser } from '../../Services/allApi';

function AddAdmins() {
  const navigate = useNavigate();
  const [newUserData,setnewUserData]=useState({first_name:'',last_name:'',email:'',password:'',phone_number:''})
  
  const handleAddNewUser=async()=>{
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
        "Content-Type": "application/json", "Authorization": `${token}`
    };
    // console.log(newUserData);
    const res=await AddNewAdminUser(newUserData,reqHeader)
    console.log(res);
    
    
  }
  return (
    <div className='w-full h-full flex justify-center p-4' style={{ fontFamily: 'ropa sans' }}>
      <div className='w-full max-w-10/12 flex flex-col bg-gray-100 shadow-md rounded-lg p-4'>
        <div className='flex justify-center mb-8'>
          <h2 className='mt-4 md:text-2xl text-lg font-semibold'>Add New User</h2>
        </div>

        {/* Form Rows */}
        <div className='flex flex-wrap -mx-4'>

          {/* First Name */}
          <div className='mt-4 px-4 w-full md:w-1/3'>
            <label htmlFor="fname" className='block text-gray-700 mb-2'>First Name</label>
            <input value={newUserData.first_name} onChange={(e)=>setnewUserData({...newUserData,first_name:e.target.value})} type="text" id="fname" className='w-full h-10 rounded-lg border border-gray-500 px-4 focus:outline-none focus:border-blue-500' />
          </div>

          {/* Last Name */}
          <div className='mt-4 px-4 w-full md:w-1/3'>
            <label htmlFor="lname" className='block text-gray-700 mb-2'>Last Name</label>
            <input value={newUserData.last_name} onChange={(e)=>setnewUserData({...newUserData,last_name:e.target.value})} type="text" id="lname" className='w-full h-10 rounded-lg border border-gray-500 px-4 focus:outline-none focus:border-blue-500' />
          </div>

          {/* Email */}
          <div className='mt-4 px-4 w-full md:w-1/3'>
            <label htmlFor="Username" className='block text-gray-700 mb-2'>Email</label>
            <input value={newUserData.email} onChange={(e)=>setnewUserData({...newUserData,email:e.target.value})} type="text" id="Username" className='w-full h-10 rounded-lg border border-gray-500 px-4 focus:outline-none focus:border-blue-500' />
          </div>

          {/* Password */}
          <div className='mt-4 px-4 w-full md:w-1/3'>
            <label htmlFor="Password" className='block text-gray-700 mb-2'>Password</label>
            <input value={newUserData.password} onChange={(e)=>setnewUserData({...newUserData,password:e.target.value})} type="password" id="Password" className='w-full h-10 rounded-lg border border-gray-500 px-4 focus:outline-none focus:border-blue-500' />
          </div>

          {/* Phone Number */}
          <div className='mt-4 px-4 w-full md:w-1/3'>
            <label htmlFor="Phone" className='block text-gray-700 mb-2'>Phone Number</label>
            <input value={newUserData.phone_number} onChange={(e)=>setnewUserData({...newUserData,phone_number:e.target.value})} type="text" id="Phone" className='w-full h-10 rounded-lg border border-gray-500 px-4 focus:outline-none focus:border-blue-500' />
          </div>

          <div className='mt-4 px-4 w-full md:w-1/3 '>
          <label htmlFor="Phone" className='block text-gray-700 mb-2' style={{visibility:'hidden'}}>Phone Number</label>
            <div className='flex justify-end items-end '>
          <button onClick={handleAddNewUser} className='h-10 bg-primary text-white w-28 rounded-lg mr-4 hover:bg-blue-900 transition ease-in-out duration-300'>
            Save
          </button>
          <button className='h-10 bg-white text-blue-500 w-28 rounded-lg border-2 border-blue-500 hover:bg-blue-100 transition ease-in-out duration-300'>
            Cancel
          </button>
        </div>
          </div>

        </div>

        {/* Action Buttons */}
        
      </div>

      <ToastContainer
        style={{ width: '400px' }}
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default AddAdmins;
